import { Instagram, Youtube, Facebook, Music2 } from "lucide-react";
import { Reveal } from "./Reveal";
import { track } from "../lib/analytics";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24" {...props}>
    <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9V9c-1.3 0-2.5-.4-3.5-1v6.5A5.5 5.5 0 1 1 11 9v2.2a3.3 3.3 0 1 0 2.3 3.1V3h3.2z" />
  </svg>
);

const PLATFORMS = [
  { key: "tiktok", label: "TikTok", Icon: TikTokIcon },
  { key: "instagram", label: "Instagram", Icon: Instagram },
  { key: "youtube", label: "YouTube", Icon: Youtube },
  { key: "facebook", label: "Facebook", Icon: Facebook },
];

export default function SocialSection({ socials = {} }) {
  const items = PLATFORMS.filter((p) => socials[p.key]);
  if (items.length === 0) return null;
  return (
    <section id="social" data-testid="social-section" className="px-6 py-16 sm:px-10 sm:py-20 lg:px-16">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <p className="mb-2 text-xs font-bold uppercase tracking-[0.3em] text-gold">Follow</p>
          <h2 className="mb-8 font-display text-3xl font-bold uppercase tracking-tight text-white sm:text-5xl">
            Connect
          </h2>
        </Reveal>
        <div className="flex flex-wrap gap-3">
          {items.map(({ key, label, Icon }) => (
            <a
              key={key}
              href={socials[key]}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-${key}`}
              onClick={() => track(`${key}_click`, { metadata: { placement: "social_section" } })}
              className="group inline-flex items-center gap-3 rounded-2xl border border-white/10 bg-surface/60 px-5 py-4 transition-transform active:scale-95 hover:border-gold/40"
            >
              <span className="text-white/80 transition-colors group-hover:text-gold">
                <Icon size={22} />
              </span>
              <span className="font-display text-base font-semibold text-white">{label}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
